var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h4',{staticClass:"modal-title"},[_vm._v("Private chat will be ended")]),_c('div',{staticClass:"center-block"},[_c('button',{staticClass:"btn btn-success",on:{"click":_vm.reloadPage}},[_vm._v("Go to page")])])])}
var staticRenderFns = []

export { render, staticRenderFns }